export function inIframe() {
  // https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export function postMessageToSameOrigin(message) {
  try {
    if (origin != parent.origin) { return; }
  } catch(e) {
    return;
  }

  parent.postMessage(message, window.origin);
}